module.exports = __webpack_public_path__ + "img/map-img-skeleton-sm.70c22645.webp";